import { useDataGrid } from '@refinedev/mui';
import { getDefaultFilter, HttpError } from '@refinedev/core';
import { ParticipantProfile } from '@aphp-ema/common/participant';
import { ParticipantFilters, useParticipantListColumns } from '../components';

export const useParticipantsList = () => {
  const { dataGridProps, search, filters } = useDataGrid<
    ParticipantProfile,
    HttpError,
    ParticipantFilters
  >({
    resource: 'admin/participants',
    onSearch: (search) => {
      if (search.email === undefined || search.email.length < 3) return [];
      return [{ field: 'email', operator: 'contains', value: search.email }];
    },
  });

  const columns = useParticipantListColumns();
  const defaultFilters = {
    email: getDefaultFilter('email', filters, 'eq'),
  };

  return {
    dataGridProps,
    search,
    defaultFilters,
    columns,
  };
};
